import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SaveAttendanceParameters, saveAttendance } from 'src/api/attendanceAPI';
import ApiError from 'src/api/errorHandling/ApiError';
import Attendance from 'src/models/Attendance';

export default function useSaveAttendance() {
  const queryClient = useQueryClient();

  return useMutation<Attendance[], ApiError, SaveAttendanceParameters>(async parameters => {
    const result = await saveAttendance(parameters);
    queryClient.invalidateQueries(['attendance']);
    queryClient.invalidateQueries(['SigningFormPage']);
    return result;
  });
}
